import classNames from 'classnames';
import React from 'react';
import { v4 as uuid } from 'uuid';

import { ActionLink } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { useConfig } from '../../defaultConfig';
import { AccountId, BillingSummary } from '../../generated-types';
import { useTranslation } from '../../translations';
import getExtraPaymentUrl from '../../utils/getExtraPaymentUrl';
import { kredittbankenTrackingIDs } from '../../utils/gtm/kredittbankenTrackingIds';
import LoanActionSkeleton from './LoanActionSkeleton';

import './LoanActions.scss';

interface Props {
    isLoading: boolean;
    billingSummary?: BillingSummary;
    className?: string;
    accountId?: AccountId;
    isDesktop?: boolean;
}

const LoanActions: React.FC<Props> = ({ isLoading, accountId, className, billingSummary, isDesktop = true }) => {
    const translated = useTranslation();
    const getExtraPaymentLink = getExtraPaymentUrl();
    const {
        links: { loanDetails },
    } = useConfig();

    if (isLoading) {
        return <LoanActionSkeleton isDesktop={isDesktop} />;
    }

    return (
        <article key={uuid()} className={classNames(className, 'loan-actions__wrapper')}>
            {billingSummary && (
                <ActionLink
                    href={getExtraPaymentLink(billingSummary)}
                    icon={IconTypes.OVERFOERE_36}
                    data-track-id={kredittbankenTrackingIDs.loanOverviewActions}
                    data-track-linkname={translated.loanOverview.extraPayment}
                >
                    {translated.loanOverview.extraPayment}
                </ActionLink>
            )}
            {loanDetails?.url && (
                <ActionLink
                    icon={IconTypes.MER_36}
                    href={`${loanDetails.url}/?id=${accountId?.toString()}`}
                    data-track-id={kredittbankenTrackingIDs.loanOverviewActions}
                    data-track-linkname={translated.loanOverview.more}
                >
                    {translated.loanOverview.more}
                </ActionLink>
            )}
        </article>
    );
};

export default LoanActions;
